import React from 'react';
import '../css/JourneyCTA.css';

const JourneyCTA = () => {
  return (
    <section className="gfi-journey-cta-section">
      <div className="gfi-journey-cta-container">
        
        {/* TOP LAYOUT TYPOGRAPHY SYSTEM */}
        <div className="gfi-jcta-header-block">
          <h2 className="gfi-jcta-main-title">
            Embark on a Journey Towards a Safer Future Together
          </h2>
          
          <div className="gfi-jcta-paragraph-wrapper">
            <p className="gfi-jcta-sub-description">
              Greenfield Academy is more than an institute; it's a movement towards global industrial safety excellence.
            </p>
          </div>
        </div>

        {/* INTERACTIVE ACTION BUTTON TRACK MESH */}
        <div className="gfi-jcta-buttons-flex-row">
          
          <button className="gfi-jcta-btn-primary" onClick={() => window.location.href = '#contact'}>
            START YOUR JOURNEY
          </button>
          
          <button className="gfi-jcta-btn-secondary" onClick={() => window.location.href = '#courses'}>
            EXPLORE PROGRAMS
          </button>

        </div>

      </div>
    </section>
  );
};

export default JourneyCTA;